
import service from '../../common/service'
import {list2map,list2tree,list2mapTree} from '../../common/tool'

const channelService  = new service({baseUrl:'/web/channel/'});

export default {
    namespaced:true,
    state:{
        id:'',
        list:[],
        listLoaded:false,
        channel:{},
        brother:[],
    },getters:{
        id:(state)=>{
            return state.id;
        },
        list:(state)=>{
            return state.list;
        },
        tree:(state)=>{
            return list2tree(state.list,'id','parentId');
        },
        map:(state)=>{
            return list2map(state.list,'id');
        },
        mapTree:(state)=>{
            return list2mapTree(state.list,'id','parentId');
        },
        channel:(state)=>{
            return state.channel;
        },
        brother:(state)=>{
            return state.brother;
        }
    },mutations:{
        setId:(state,id)=>{
            state.id = id;
        },
        setChannel:(state,d)=>{
            state.channel = {...d};
        },
        setBrother:(state,d)=>{
            state.brother = [...d];
        },
        setList:(state,d)=>{
            state.list = [...d];
        }
    },
    actions:{
        find(context){
            if(context.state.listLoaded) return Promise.resolve();
            return channelService.get('').then((res)=>{
                let json = res.data;
                if(json.success){
                    let ls = json.data||[];
                    ls.forEach((o,i)=>{
                        switch (o.type) {
                            case 0:
                                o.to="/";break;
                            case 1:
                                if(o.dataId){
                                    o.to = `/channel/${o.id}/${o.dataId}`;
                                }else{
                                    o.to = `/channel/${o.id}`;
                                }
                                break;
                            case 2:
                                o.to = `/channel/${o.id}`;
                                break;
                        }
                    });
                    context.commit('setList',ls);
                    context.state.listLoaded = true;
                }else{
                    return Promise.reject(json);
                }
            })
        },
        fetch(context,id){
            context.commit('setId',id);
        }
    }
}